import { Box, Typography, Stack, AspectRatio } from '@mui/joy';
import { Event as EventIcon } from '@mui/icons-material';
import { useGetEventsQuery } from '@/features/events/api';
import { Link } from '@/components/Link';

export function EventPickerList({ householdId, onAdd }) {
  const { data, isLoading } = useGetEventsQuery({ householdId });
  const events = data?.data || [];

  return (
    <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden' }}>
      {isLoading && <Typography level="body-sm">Loading events...</Typography>}

      {!isLoading && events.length === 0 && (
        <Typography level="body-sm" sx={{ color: 'var(--joy-palette-neutral-400)' }}>
          No events yet. <Link to={`/h/${householdId}/settings/events`}>Create one</Link> to get started.
        </Typography>
      )}

      <Stack gap={1}>
        {events.map((event) => (
          <Box
            key={event.id}
            onClick={() => onAdd(event.id)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              p: 1,
              borderRadius: 'sm',
              cursor: 'pointer',
              '&:hover': { bgcolor: 'background.level1' },
            }}
          >
            <AspectRatio ratio="1" sx={{ width: 48, borderRadius: 'sm', flexShrink: 0 }}>
              {event.image?.url ? (
                <img src={event.image.url} srcSet={event.image.srcset} sizes="48px" alt={event.name} />
              ) : (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'text.tertiary' }}>
                  <EventIcon />
                </Box>
              )}
            </AspectRatio>
            <Typography level="body-md">{event.name}</Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
